import React from 'react';

import { useTranslation } from 'react-i18next';

import DateRangePickerButton from '../../../form/DatePickers/DateRangePickerButton';

type ShopifyDateRangePickerButtonProps = {
  className?: string;
  startDate: Date | null;
  endDate: Date | null;
  startCreationDate: Date | null;
  endCreationDate: Date | null;
  defaultStartDate: Date;
  defaultEndDate: Date;
  handleChange: (props: any) => void;
};

export default function ShopifyDateRangePickerButton({
  className,
  startDate,
  endDate,
  startCreationDate,
  endCreationDate,
  defaultStartDate,
  defaultEndDate,
  handleChange,
}: ShopifyDateRangePickerButtonProps) {
  const { t } = useTranslation();

  return (
    <>
      <div>
        <span>{t('Creation date')}</span>
        <DateRangePickerButton
          className={className}
          startDate={startCreationDate || new Date()}
          // @ts-expect-error ts-migrate(2322) FIXME: Type 'Date | null' is not assignable to type 'neve... Remove this comment to see the full error message
          endDate={endCreationDate}
          minRangeSize={1}
          maxRangeSize={365}
          shouldShowDefaultButtonText={!startCreationDate}
          maxDate={new Date()}
          onChange={({ startDate, endDate }: any) => {
            handleChange({
              startCreationDate: startDate || startCreationDate || new Date(),
              endCreationDate: endDate || endCreationDate || new Date(),
              page: 0,
            });
          }}
        />
      </div>
      <div>
        <span>{t('Burst date')}</span>
        <DateRangePickerButton
          className={className}
          startDate={startDate || defaultStartDate}
          endDate={endDate || defaultEndDate}
          shouldShowDefaultButtonText={!startDate}
          minRangeSize={1}
          maxRangeSize={365}
          onChange={({ startDate: startDateTime, endDate: endDateTime }) =>
            handleChange({
              startDate: startDateTime || startDate || defaultStartDate,
              endDate: endDateTime || endDate || startDate || defaultEndDate,
              page: 0,
            })
          }
        />
      </div>
    </>
  );
}
